import useLanguageStore from 'components/AppLanguagePicker/store';
import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import enTranslations from './lng/en.json';

const languageImports: Record<string, () => Promise<{default: object}>> = {
  es: () => import('./lng/es.json'),
  fr: () => import('./lng/fr.json'),
  it: () => import('./lng/it.json'),
  ja: () => import('./lng/ja.json'),
  ko: () => import('./lng/ko.json'),
  pt: () => import('./lng/pt.json'),
};

const LazyImportBackend = {
  type: 'backend' as const,
  init() {},
  read(
    language: string,
    _namespace: string,
    callback: (err: Error | null, data: object | null) => void,
  ) {
    if (language === 'en') {
      callback(null, enTranslations);
      return;
    }
    languageImports[language]?.()
      .then((mod) => callback(null, mod.default))
      .catch((err) => callback(err, null));
  },
};

i18n
  .use(LazyImportBackend)
  .use(initReactI18next)
  .init({
    lng: useLanguageStore.getState().language || 'en',
    fallbackLng: 'en',
    debug: false,
    partialBundledLanguages: true,
    resources: {
      en: {
        translation: enTranslations,
      },
    },

    interpolation: {
      escapeValue: false,
    },

    defaultNS: 'translation',
    ns: ['translation'],
  });

export default i18n;
